<div class="row">
  <div class="col-md-12">
    <mat-card appearance="outlined" class="marB16">
      <div *ngIf="editactivity">
        <button mat-icon-button class="close-button" [mat-dialog-close]="true">
          <mat-icon class="close-icon" color="warn">close</mat-icon>
        </button>
      </div>
      <div class="d-flex justify-content-between" style="margin-left: 18px; margin-top: 18px">
        <div class="txt_left">
          <h4 class="h3Header GreyDarkest text-1line marB16">Communicate with candidate</h4>
        </div>

        <div class="d-flex" style="margin-right: 18px">
          <span class="data-letters float-left marR6 listleft">{{ loginUserName || 'NA' | initials }}</span>
          <h5 class="marginicon40 h5Header GreyLight marT8 float-right marR16">{{ loginUserName }}</h5>
          <span class="float-right marT4">
            <span class="marginicon40 mainBodyTxt3 GreyLight blockInfo" *ngIf="timeModifiedOn; else elseTemplate">
              {{ timeModifiedOn | dateTransform }}
            </span>
            <ng-template class="mainBodyTxt3 GreyLight blockInfo" #elseTemplate> </ng-template>
          </span>
        </div>
      </div>

            <div *ngIf="ROA" [ngClass]="{'readActivityDisable': data && data.readflag}">
                <mat-checkbox class="custom-checkbox" aria-label="checkbox" disableRipple="true" name="MailCheck" [(ngModel)]="RejectionMailCheck">Send email communication to candidate</mat-checkbox>
                </div>
            <mat-card-content *ngIf="isCollapsed" [ngClass]="{'readActivityDisable': data && data.readflag}">
                    <form  name="correpForm" #f1="ngForm">
                            <div *ngIf="this.testformValid(!f1.invalid)">               
                       
                                </div> 
                    <div *ngIf="RejectionMailCheck"> 
                    <mat-form-field style = "width:25%">


                    <mat-label>Template</mat-label>
                    <mat-select (selectionChange)="getTemplateData($event)" required name="coupledtemplate" [(ngModel)]="selectedTemplate" matTooltip="{{temaplateName}}" matTooltipClass="customTooltip" [disabled]="templateDisable">
                        <ng-container *ngFor="let status of templateData">
                            <mat-option [value]="status.templateId" [disabled]="isTemplateLocked(status)" matTooltip="{{status.templateName}}" class="custom-select-option">
                                {{status.templateName}}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>

            <div class="row">
              <div class="col-md-10">
                <mat-form-field class="custom-form-field">
                  <input
                    #toValue
                    matInput
                    placeholder="To"
                    required
                    name="coupledtoInput"
                    [value]=""
                    [disabled]="toDisable"
                    (input)="toInputValue = $event.target.value"
                    [(ngModel)]="toInputValue"
                  />
                </mat-form-field>
              </div>
              <button
                mat-icon-button
                class="text-btn"
                name="coupledccbtn"
                (click)="ccEnableDisable()"
                style="font-size: 16px"
              >
                CC
              </button>
              <button
                mat-icon-button
                class="text-btn"
                name="coupledbccbtn"
                (click)="bccEnableDisable()"
                style="font-size: 16px"
              >
                BCC
              </button>
            </div>

            <!-- *ngIf is apt for this; but data not sending to compo; should look; as of now using visibility property -->

            <mat-form-field class="custom-form-field" [ngStyle]="{ visibility: ccEnable ? 'visible' : 'hidden' }">
              <input
                #ccValue
                matInput
                placeholder="CC"
                name="coupledccinput"
                [value]=""
                [(ngModel)]="ccInputValue"
                (input)="ccInputValue = $event.target.value"
              />
            </mat-form-field>
            <!-- *ngIf is apt for this; but data not sending to compo; should look; as of now using visibility property -->
            <mat-form-field class="custom-form-field" [ngStyle]="{ visibility: bccEnable ? 'visible' : 'hidden' }">
              <!-- <mat-form-field class="custom-form-field"  *ngIf="bccEnable"> -->
              <input
                #bccValue
                matInput
                placeholder="BCC"
                name="coupledbccinput"
                [value]=""
                [(ngModel)]="bccInputValue"
                (input)="bccInputValue = $event.target.value"
              />
            </mat-form-field>

            <mat-form-field class="custom-form-field">
              <input
                #subjectValue
                matInput
                placeholder="Subject"
                required
                name="coupledsubjectinput"
                [value]=""
                (input)="subjectInputValue = $event.target.value"
                [(ngModel)]="subjectInputValue"
                appNoWhiteSpc
              />
            </mat-form-field>

            <mat-form-field class="custom-form-field">
              <textarea
                #bodyValue
                matInput
                rows="10"
                placeholder="Body"
                required
                name="coupledbodyinput"
                (input)="bodyInputValue = $event.target.value"
                [(ngModel)]="bodyInputValue"
                appNoWhiteSpc
              ></textarea>
            </mat-form-field>

            <mat-form-field class="custom-form-field">
              <input
                matInput
                [(ngModel)]="remarksInputValue"
                name="coupledremarksinput"
                #remarksValue
                placeholder="Remarks"
                value=""
                (input)="remarksInputValue = $event.target.value"
              />
            </mat-form-field>

            <div>
              <app-attachment
                (fileOutput)="receiveFileOutput($event)"
                [toggleBtn]="toggleBtn"
                [allowedTypes]="allowedTypes"
                [uploadType]="multiple"
                [editId]="editId"
                activityModuleFlag="true"
              ></app-attachment>
            </div>

            <div class="row" *ngIf="!ifCoupled">
              <div class="col-md-4" *ngIf="!interviewFlag">
                <div class="row nomarLR padTB16">
                  <div class="col-6 padR8">
                    <button
                      mat-raised-button
                      class="primary-btn btnfullWdth"
                      type="submit"
                      [disabled]="f1.invalid"
                      name="coupledsendbtn"
                      (click)="send()"
                    >
                      Send
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </mat-card-content>
      <mat-card-actions class="collapseAction m-auto">
        <div>
          <mat-card-actions class="collapseAction">
            <div>
              <a
                href="javascript:void(0)"
                name="collapseAction"
                *ngIf="isCollapsed"
                class="icon x-24"
                (click)="showMoreLess()"
              >
                <img src="../assets/images/icons/orange_icons/icon-collapse-arrow.png" alt="icon-collapse" />
              </a>
              <a
                href="javascript:void(0)"
                name="collapseAction"
                *ngIf="!isCollapsed"
                class="icon x-24"
                (click)="showMoreLess()"
              >
                <img src="../assets/images/icons/orange_icons/icon-expand-arrow.png" alt="icon-expand" />
              </a>
            </div>
          </mat-card-actions>
        </div>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
